import { Injectable, Injector } from '@angular/core';
import { BaseState } from 'src/app/common/base/base.state'; import { Action, State, Selector, StateContext } from '@ngxs/store';
// import { utils } from 'src/app/modules/Libs/utils';
// import { RadiationAreaService } from 'src/app/Services/RadiationArea/radiation-area-service.service';
// import { RadiationAreaItem } from 'src/app/_interface/RadiationAreaItem';
import { RadiationAreaRefresh, RadiationAreaCreate, RadiationAreaUpdate, RadiationAreaDelete } from './radiation-area.action';
import { utils } from 'src/app/modules/libs/utils';
import { RadiationAreaItem } from '../radiation-area-item';
import { RadiationAreaService } from '../radiation-area-service.service';
import { readStatusSnapshot, writeStatusSnapshot } from '../../status-snapshot-cache';

const RADIATION_AREA_SNAPSHOT_KEY = 'home:radiation-area:snapshot';

export class RadiationAreaStateModel {
  radiationAreaItems!: RadiationAreaItem[];
  loading!: boolean;
}

@State<RadiationAreaStateModel>({
  name: 'RadiationArea',
  defaults: {
    radiationAreaItems: [],
    loading: false
  }
})
@Injectable()
export class RadiationAreaState extends BaseState {
  constructor(
    protected override injector: Injector,
    private radiationAreaService: RadiationAreaService

  ) {
    super(injector);
  }

  @Selector()
  static read(state: RadiationAreaStateModel) {
    return state.radiationAreaItems;
  }

  @Action(RadiationAreaRefresh)
  refresh({ getState, patchState }: StateContext<RadiationAreaStateModel>) {
    patchState({ loading: true });

    if (!getState().radiationAreaItems?.length) {
      const snapshot = readStatusSnapshot<RadiationAreaItem[]>(RADIATION_AREA_SNAPSHOT_KEY);
      if (snapshot?.length) patchState({ radiationAreaItems: snapshot });
    }

    this.radiationAreaService.getAll().toPromise().then(data => {
      const radiationAreaItems = utils.cloneDeep(data);
      patchState({ radiationAreaItems, loading: false });
      writeStatusSnapshot(RADIATION_AREA_SNAPSHOT_KEY, radiationAreaItems);
    }).catch(error => {
      patchState({ loading: false });
      console.error(error);
    });
  }

  @Action(RadiationAreaCreate)
  create({ getState, patchState }: StateContext<RadiationAreaStateModel>, { item }: RadiationAreaCreate) {
    const radiationAreaItems = [...getState().radiationAreaItems, item];
    patchState({ radiationAreaItems });
    writeStatusSnapshot(RADIATION_AREA_SNAPSHOT_KEY, radiationAreaItems);
  }

  @Action(RadiationAreaUpdate)
  update({ getState, patchState }: StateContext<RadiationAreaStateModel>, { id, item }: RadiationAreaUpdate) {
    const state = getState();
    const index = state.radiationAreaItems.findIndex(x => x.id === id);
    const currentState = utils.cloneDeep(state.radiationAreaItems);

    if (index >= 0) {
      currentState.splice(index, 1, utils.cloneDeep(item));
      patchState({ radiationAreaItems: currentState });
      writeStatusSnapshot(RADIATION_AREA_SNAPSHOT_KEY, currentState);
    }
  }

  @Action(RadiationAreaDelete)
  delete({ getState, patchState }: StateContext<RadiationAreaStateModel>, { id }: RadiationAreaDelete) {
    const radiationAreaItems = getState().radiationAreaItems.filter(x => x.id !== id);
    patchState({ radiationAreaItems });
    writeStatusSnapshot(RADIATION_AREA_SNAPSHOT_KEY, radiationAreaItems);
  }
}
